var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { id: "dictamen-general", fluid: "" } },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.guardarDictamen.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "line-break" }),
          _vm._v(" "),
          _c("b-container", {
            staticClass: "border text-justify",
            attrs: { id: "dictamen" },
          }),
          _vm._v(" "),
          _c(
            "b-container",
            {
              staticClass: "border text-justify",
              attrs: { id: "dictamen-solicitud" },
            },
            [
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    [
                      _vm.esAprobado
                        ? [
                            _c("p", [
                              _vm._v(
                                "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso c, 15, 17, 18, fracción III, 19, fracción V, 20 y\n              21 del Reglamento del Sistema Nacional de Investigadoras e Investigadores (SNII); y 50, 53, 55, 56 y 57 de los Lineamientos\n              para el Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del SNII, la Comisión de Investigadoras e Investigadores Nacionales Eméritos recomienda al Consejo\n              General del Sistema Nacional de Investigadoras e Investigadores otorgar el nivel de\n              "
                              ),
                              _c("strong", [
                                _c("span", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.solicitud.SOLICITUD_RIZOMA
                                          .solicitante.sexo.id ===
                                        _vm.Masculino,
                                      expression:
                                        "solicitud.SOLICITUD_RIZOMA.solicitante.sexo.id === Masculino",
                                    },
                                  ],
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("dictamenEmeritos.aceptadoM2026")
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.solicitud.SOLICITUD_RIZOMA
                                          .solicitante.sexo.id === _vm.Femenino,
                                      expression:
                                        "solicitud.SOLICITUD_RIZOMA.solicitante.sexo.id === Femenino",
                                    },
                                  ],
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("dictamenEmeritos.aceptadoF2026")
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(".\n            "),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n              Por lo anterior, y tomando en cuenta la valoración respecto de la trayectoria del solicitante a partir del análisis de la\n              información registrada en el Perfil Único y las consideraciones presentadas en su solicitud de conformidad con lo\n              establecido en el marco de la Convocatoria 2026 para Investigadora o Investigador Nacional Emérito en el Sistema Nacional de\n              Investigadoras e Investigadores, se determina que cumple con los Criterios Específicos de Evaluación. Asimismo, la persona\n              solicitante cumple con los requisitos previstos en el artículo 19, fracción V, del Reglamento del Sistema Nacional de\n              Investigadoras e Investigadores.\n            "
                              ),
                            ]),
                          ]
                        : _vm.esNoAprobado
                        ? [
                            _c("p", [
                              _vm._v(
                                "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso c, 15, 17, 18, fracción III, 19, fracción V, 20 y\n              21 del Reglamento del Sistema Nacional de Investigadoras e Investigadores (SNII); y 50, 53, 55, 56 y 57 de los Lineamientos\n              para el Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del SNII, la Comisión de Investigadoras e Investigadores Nacionales Eméritos recomienda al Consejo\n              General del Sistema Nacional de Investigadoras e Investigadores\n              "
                              ),
                              _c("strong", [
                                _vm._v(" no aprobar la solicitud"),
                              ]),
                              _vm._v(".\n            "),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n              Se recomienda no aprobar la solicitud debido a que la valoración de la trayectoria no cumple con lo establecido en los\n              Criterios Específicos de Evaluación del SNII, se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando\n              "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.descripcionComprensibleDictamen)
                                ),
                              ]),
                              _vm._v(".\n            "),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n              En resumen, la Comisión de Investigadoras e Investigadores Nacionales Eméritos considera que la trayectoria de investigación\n              presentada no cumple con lo previsto en el artículo 19, fracción V, del Reglamento del Sistema Nacional de Investigadoras e\n              Investigadores, así como los Criterios Específicos de Evaluación por:\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("b-form-textarea", {
                                  staticClass: "textarea-dictamen-negativo",
                                  attrs: {
                                    rows: "6",
                                    "max-rows": "12",
                                    state:
                                      _vm.caracteresComentarioDictamenNegativo >=
                                      _vm.caracteresMinimos,
                                    maxlength: _vm.caracteresMaximos,
                                    placeholder: String(
                                      _vm.$t(
                                        "dictamenEmeritos.placeholderComentario"
                                      )
                                    ),
                                    disabled:
                                      _vm.revision.estado !== _vm.aceptada,
                                  },
                                  on: {
                                    input:
                                      _vm.limitarComentariosDictamenNegativo,
                                    blur: _vm.tocarComentariosDictamenNegativo,
                                  },
                                  model: {
                                    value: _vm.dictamenEmerito.comentarios,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dictamenEmerito,
                                        "comentarios",
                                        $$v
                                      )
                                    },
                                    expression: "dictamenEmerito.comentarios",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-end mt-1",
                                  },
                                  [
                                    _vm.comentarioDictamenNegativoRequerido
                                      ? _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " El comentario es obligatorio. "
                                            ),
                                          ]
                                        )
                                      : _vm.caracteresComentarioDictamenNegativo <
                                        _vm.caracteresMinimos
                                      ? _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                  El mínimo requerido es de " +
                                                _vm._s(_vm.caracteresMinimos) +
                                                " caracteres.\n                "
                                            ),
                                          ]
                                        )
                                      : _c("small", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.caracteresComentarioDictamenNegativo
                                              ) +
                                              " de " +
                                              _vm._s(_vm.caracteresMaximos) +
                                              " caracteres. "
                                          ),
                                        ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "line-break" }),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("div", { staticClass: "border-top mt-4 mb-4" }, [
                  _c("div", { staticClass: "mb-5 float-right" }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "mb-5 float-right" },
                  [
                    _vm.revision.estado === _vm.aceptada
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              size: "md",
                              disabled:
                                (_vm.hasAnyAuthority("ROLE_OPERADOR") &&
                                  _vm.authenticated) ||
                                !_vm.authenticated ||
                                !_vm.habilitarSave,
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("entity.action.save")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              staticClass: "mr-2",
                              attrs: { icon: "save" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }